module.exports = __webpack_public_path__ + "img/logo-google-webdev.d19561a5.svg";